// @flow

import deepMapKeys from 'app/common/lib/util/ObjectUtils/deepMapKeys';

type StringKeyMapper = (key: string) => string;

// Takes a string manipulation function and returns a deepMapKeys function
// Eliminates need to wrapped the string function to format it for lodash.mapKeys
export default function deepMapStringKeys(fn: StringKeyMapper, enterLists: boolean = false) {
  const mapper = (_: any, k: string) => fn(k);
  return (obj: Object) => deepMapKeys(mapper, enterLists)(obj);
}
